import { motion } from "framer-motion";
import { Flame, Clock, MapPin, ArrowRight } from "lucide-react";
import { DemoBar } from "@/components/DemoBar";
import { CASES } from "@/data/cases";

const img = CASES.find((c) => c.slug === "fastfood").image;

const MENU = [
  { name: "Den klassiske", desc: "Oksekød, cheddar, syltede agurker, husets dressing", price: "89 kr" },
  { name: "Dobbelt op", desc: "To bøffer, dobbelt ost, bacon og karamelliserede løg", price: "119 kr" },
  { name: "Den grønne", desc: "Halloumi, avokado, chipotle-mayo og sprød salat", price: "95 kr" },
  { name: "Chili-cheese fritter", desc: "Sprøde fritter med ostesovs og jalapeños", price: "49 kr" },
];

export default function FastfoodDemo() {
  return (
    <div data-testid="demo-fastfood" className="min-h-screen bg-[#120B08] text-[#FBF3E8]">
      <DemoBar name="Burger Basen" />

      <header className="flex items-center justify-between px-6 py-6 md:px-12">
        <p className="font-syne text-xl font-extrabold tracking-tight">
          BURGER <span className="text-[#FFB020]">BASEN</span>
        </p>
        <button data-testid="fastfood-order-button" className="rounded-full bg-[#FFB020] px-6 py-2.5 text-sm font-bold text-[#120B08] transition-transform duration-300 hover:scale-105">
          Bestil afhentning
        </button>
      </header>

      <section className="grid grid-cols-1 items-center gap-12 px-6 py-16 md:grid-cols-2 md:px-12 md:py-24">
        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <p className="flex items-center gap-2 text-sm uppercase tracking-[0.3em] text-[#FFB020]">
            <Flame className="h-4 w-4" /> Frisk fra grillen
          </p>
          <h1 className="mt-4 font-syne text-5xl font-extrabold uppercase leading-[0.9] tracking-tighter md:text-7xl">
            Saftige burgere. <span className="text-[#FFB020]">Hurtigt.</span>
          </h1>
          <p className="mt-6 max-w-md text-[#C9B8A3]">
            Hjemmelavede bøffer, brioche-boller bagt hver morgen og fritter skåret i hånden.
            Bestil online — hent på 10 minutter.
          </p>
          <div className="mt-8 flex flex-wrap gap-6 text-sm text-[#C9B8A3]">
            <span className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#FFB020]" /> Alle dage 11–22</span>
            <span className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#FFB020]" /> Gadegaden 12, København</span>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="overflow-hidden rounded-[2rem] border border-white/10"
        >
          <img src={img} alt="Saftig burger hos Burger Basen" data-testid="fastfood-hero-image" className="aspect-[4/3] w-full object-cover" />
        </motion.div>
      </section>

      <section className="border-t border-white/10 px-6 py-20 md:px-12">
        <h2 className="font-syne text-3xl font-extrabold uppercase tracking-tighter md:text-5xl">Menuen</h2>
        <div data-testid="fastfood-menu" className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
          {MENU.map((m, i) => (
            <motion.div
              key={m.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group rounded-2xl border border-white/10 p-6 transition-colors duration-300 hover:border-[#FFB020]/60"
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-syne text-xl font-bold">{m.name}</h3>
                  <p className="mt-2 text-sm text-[#C9B8A3]">{m.desc}</p>
                </div>
                <p className="font-syne text-xl font-bold text-[#FFB020]">{m.price}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <button data-testid="fastfood-menu-cta" className="group mt-12 flex items-center gap-2 rounded-full bg-[#FFB020] px-8 py-4 text-sm font-bold text-[#120B08] transition-transform duration-300 hover:scale-105">
          Se hele menuen <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </section>

      <footer className="border-t border-white/10 px-6 py-10 text-center text-sm text-[#C9B8A3] md:px-12">
        Burger Basen · Gadegaden 12 · 2200 København N · Tlf. 12 34 56 78
      </footer>
    </div>
  );
}
